import ErrorMessage from '@/components/common/error-message/ErrorMessage';
import GoBack from '@/components/common/go-back/GoBack';
import AlertModal from '@/components/common/modals/alert-modal/AlertModal';
import NoData from '@/components/common/no-data/NoData';
import FormInventoryCategory from '@/components/forms/form-inventory-category/FormInventoryCategory';
import { Skeleton } from '@/components/ui/skeleton';
import useEditInventoryCategory from '@/hooks/pages/useEditInventoryCategory';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

const EditInventoryCategory = () => {
  const { t } = useTranslation();
  const [deleteModal, setDeleteModal] = useState(false);
  const {
    isError,
    isLoading,
    isPending,
    sports,
    invetoryType,
    deleteEquipmentType,
    isPendingDelete,
    onSubmit,
    defaultValues
  } = useEditInventoryCategory();

  if (isLoading) {
    return (
      <>
        <GoBack />
        <Skeleton className="w-full h-[332px]" />
      </>
    );
  }

  if (!invetoryType || !sports) {
    return (
      <>
        <GoBack />
        <NoData />
      </>
    );
  }

  if (isError) {
    return (
      <>
        <GoBack />
        <ErrorMessage />
      </>
    );
  }

  return (
    <>
      <GoBack />
      <div className="flex justify-center w-full">
        <FormInventoryCategory
          onSubmit={onSubmit}
          isPending={isPending}
          defaultValues={defaultValues}
          sports={sports}
          isPendingDelete={isPendingDelete}
          onDelete={() => setDeleteModal(true)}
        />
      </div>
      <AlertModal
        open={deleteModal}
        onOpenChange={setDeleteModal}
        title={t('modals.deleteEquipmentType.title')}
        description={t('modals.deleteEquipmentType.description')}
        cancelText={t('common.cancel')}
        acceptText={t('form.delete')}
        onAccept={() => deleteEquipmentType(invetoryType?.id ?? '')}
        buttonAcceptDestructive
      />
    </>
  );
};

export default EditInventoryCategory;
